import { useTranslation } from "react-i18next";
import { Button, Modal } from "antd";

interface IProps {
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
}

export const TermsAndConditions: React.FC<IProps> = ({
  open,
  onOk,
  onCancel,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t("TermsAndConditionsTitle")}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      footer={[
        <Button key="accept" type="primary" onClick={onOk}>
          {t("CloseButton")}
        </Button>,
      ]}
    >
      <div style={{ maxHeight: "300px", overflowY: "scroll" }}>
        <p>
          Dobrodošli u našu aplikaciju za zakazivanje termina. Korišćenjem naše
          aplikacije, slažete se sa sledećim uslovima:
        </p>
        <ol>
          <li>
            Podaci koje unesete prilikom registracije (ime, prezime, e-mail,
            broj telefona) koristiće se isključivo za zakazivanje termina i
            obaveštavanje o promenama.
          </li>
          <li>
            Zadržavamo pravo da prenesemo vlasništvo, prava i obaveze vezane za
            ovu aplikaciju, uključujući podatke korisnika, na treću stranu u
            slučaju prodaje, spajanja ili preuzimanja aplikacije. Korisnici će
            biti obavešteni o prenosu vlasništva putem e-maila ili obaveštenja
            unutar aplikacije.
          </li>
          <li>
            Aplikacija je pružena "kakva jeste" i "kako je dostupna", bez
            garancija bilo koje vrste. Ni u kom slučaju vlasnik aplikacije neće
            biti odgovoran za bilo kakvu štetu nastalu korišćenjem aplikacije.
          </li>
          <li>
            Korisnici su odgovorni za tačnost podataka koje unose i za čuvanje
            poverljivosti svojih podataka za prijavu.
          </li>
          <li>
            Zadržavamo pravo da u bilo kom trenutku izmenimo ove uslove
            korišćenja. Sve izmene stupaju na snagu od trenutka objave.
          </li>
          <li>
            Svi elementi aplikacije zaštićeni su autorskim pravima. Korisnici ne
            smeju kopirati ili distribuirati sadržaj aplikacije bez dozvole
            vlasnika.
          </li>
          <li>
            Ovi uslovi korišćenja regulisani su zakonima Republike Srbije. Svi
            sporovi rešavaće se pred nadležnim sudom.
          </li>
        </ol>
      </div>
    </Modal>
  );
};
